import { useState } from "react";
import { CircleCheck } from "lucide-react";
import BookingCardShell, { Detail, DetailRow } from "./BookingCardShell";
import { formatPrice, formatBookingDate } from "../../utils/sessionTurnUtils";

const BookingConfirmedCard = ({ displayData }: any) => {
  const [expanded, setExpanded] = useState(false);

  const {
    bookingId,
    roomName,
    checkIn,
    checkOut,
    totalPrice,
    currency,
    guests,
    children,
  } = displayData;

  const headerSummary = [
    roomName,
    totalPrice !== undefined && totalPrice !== null
      ? formatPrice(totalPrice, currency)
      : null,
  ]
    .filter(Boolean)
    .join(" | ");

  const guestsText = [
    guests ? `${guests} adult${guests !== 1 ? "s" : ""}` : null,
    children ? `${children} child${children !== 1 ? "ren" : ""}` : null,
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <BookingCardShell
      icon={<CircleCheck />}
      tone="success"
      title="Confirmed"
      badge={bookingId ? `#${bookingId}` : undefined}
      meta={headerSummary}
      expanded={expanded}
      onToggle={() => setExpanded(!expanded)}
    >
      <DetailRow>
        {roomName && <Detail label="Room"><strong>{roomName}</strong></Detail>}
        {checkIn && <Detail label="Check-in">{formatBookingDate(checkIn)}</Detail>}
        {checkOut && <Detail label="Check-out">{formatBookingDate(checkOut)}</Detail>}
      </DetailRow>
      <DetailRow>
        {guestsText && <Detail label="Guests">{guestsText}</Detail>}
        {totalPrice !== undefined && totalPrice !== null && (
          <Detail className="font-semibold text-success-700">{formatPrice(totalPrice, currency)}</Detail>
        )}
      </DetailRow>
    </BookingCardShell>
  );
};

export default BookingConfirmedCard;
